import React, { Component } from "react";

export default class extends Component {
  onClick() {
    this.props.onClick();
  }

  render() {
    return (
      <div
        onClick={this.onClick.bind(this)}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="tableItem"
          style={{
            backgroundColor: this.props.selected
              ? "var(--brown1)"
              : "var(--gray1)",
            color: this.props.selected ? "white" : "var(--black1)",
          }}
        >
          {this.props.title}
        </div>
      </div>
    );
  }
}
